// extracted by mini-css-extract-plugin
export default {"pageArea":"UsersHome_pageArea__wuvDn","fullWidth":"UsersHome_fullWidth__MoD9U","hidden":"UsersHome_hidden__pBahd"};